document.addEventListener('DOMContentLoaded', () => {
  const SECTIONS = document.querySelectorAll('.tabbed-accordion');
  const DURATION = 450; // must match CSS transition time

  SECTIONS.forEach(section => {
    const tabs = section.querySelectorAll('.tab-item');
    const images = section.querySelectorAll('.image-set');
    const wrapper = section.querySelector('.image-wrapper');
    const select = section.querySelector('.tab-select');
    const mobileDesc = section.querySelector('.mobile-tab-desc');

    /* -------------------------
       IMAGE SWITCH FUNCTION
    -------------------------- */
    function switchImages(index) {
      const current = section.querySelector('.image-set.is-visible');
      const next = section.querySelector(`.image-set[data-tab="${index}"]`);

      if (!next || current === next) return;

      /* 🔒 Lock wrapper height */
      if (current) {
        wrapper.style.height = current.offsetHeight + 'px';
      }

      /* EXIT: slide down + fade out */
      if (current) {
        current.classList.remove('is-visible');
        current.classList.add('is-hiding');
      }

      /* ENTER after exit finishes */
      setTimeout(() => {
        if (current) {
          current.classList.remove('is-hiding');
        }

        /* Enable stagger only if 2 images */
        const imgs = next.querySelectorAll('img');
        if (imgs.length > 1) {
          next.classList.add('is-staggering');
        } else {
          next.classList.remove('is-staggering');
        }

        /* PRE-ENTER: start below */
        next.classList.add('is-entering');
        next.offsetHeight; // force reflow

        /* ENTER: slide up + fade in */
        next.classList.remove('is-entering');
        next.classList.add('is-visible');

        /* 🔓 Unlock height after enter completes */
        setTimeout(() => {
          wrapper.style.height = '';
          next.classList.remove('is-staggering');
        }, DURATION);

      }, DURATION);
    }

    /* -------------------------
       DESKTOP TABS
    -------------------------- */
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        switchImages(index);
      });
    });

    /* -------------------------
       MOBILE DROPDOWN
    -------------------------- */
    if (select && mobileDesc) {
      const firstDesc = section.querySelector('.tab-desc');
      if (firstDesc) {
        mobileDesc.innerHTML = firstDesc.innerHTML;
      }

      select.addEventListener('change', () => {
        const index = select.value;
        const desc = section.querySelector(
          `.tab-item[data-tab="${index}"] .tab-desc`
        );

        if (desc) {
          mobileDesc.innerHTML = desc.innerHTML;
        }

        switchImages(index);
      });
    }

    /* -------------------------
       INITIAL STATE
    -------------------------- */
    const firstImage = section.querySelector('.image-set');
    if (firstImage) {
      firstImage.classList.add('is-visible');
    }
  });
});


/* =========================================
   FADE IN ON VIEWPORT
========================================= */

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.tabbed-accordion');

  if (!('IntersectionObserver' in window)) {
    sections.forEach(section => section.classList.add('is-in-view'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          obs.unobserve(entry.target); // run once
        }
      });
    },
    {
      threshold: 0.15
    }
  );

  sections.forEach(section => observer.observe(section));
});
